import * as RegExpressions from "./regularExpressions";

export const validatePasswordRegExpressions = (
  value: string
): boolean | string => {
  const passes = [
    value.length >= 8,
    RegExpressions.Digits.test(value),
    RegExpressions.LowercaseLetters.test(value),
    RegExpressions.UppercaseLetters.test(value),
    RegExpressions.SpecialCharacters.test(value),
  ];

  const allValid = passes.every(Boolean);

  return allValid ? true : "Password does not meet all requirements";
};

export const clampItemQuantity = (
  v: number,
  min = 1,
  max = Number.POSITIVE_INFINITY
): number => Math.min(Math.max(v, min), max);
